
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

interface ImagePreviewProps {
  image: string | null;
}

export function ImagePreview({ image }: ImagePreviewProps) {
  const navigate = useNavigate();
  
  return (
    <div className="glass-card rounded-2xl overflow-hidden p-5 animate-fade-in">
      <div className="flex flex-col sm:flex-row gap-6">
        <div className="sm:w-1/3 aspect-[4/3] rounded-lg overflow-hidden bg-gray-100">
          {image && (
            <img 
              src={image} 
              alt="Captured objects" 
              className="w-full h-full object-cover"
            />
          )}
        </div>
        
        <div className="sm:w-2/3">
          <h2 className="text-lg font-semibold mb-2">Your Objects</h2>
          <p className="text-muted-foreground text-sm mb-4">
            We've analyzed your image and generated creative activities you can do with these objects.
          </p>
          
          <Button 
            variant="outline" 
            size="sm"
            className="gap-2"
            onClick={() => navigate("/camera")}
          >
            <ArrowLeft className="h-4 w-4" />
            Take another photo
          </Button>
        </div>
      </div>
    </div>
  );
}
